export function hasPermission (authUser, slug) {
  return authUser?.all_permission_slugs?.includes(slug);
}

export function canOnlyAccessOwnResource (authUser, resourceOwnerId) {
  return authUser?.id === resourceOwnerId;
}

export function belongsToTheCurrentPartner(authUser, partner) {
  if (!authUser || !partner) return false;
  return authUser.partner_id === partner.id;
}

export function canManagePartnerDetails (authUser, partner, permissionSlug) {
  return hasPermission(authUser, permissionSlug) && belongsToTheCurrentPartner(authUser, partner);
}